module.exports = __webpack_public_path__ + "media/images/icons/thumbs-up-93e6558640b476e6ef479483cec1d53c.svg";